module.exports = __webpack_public_path__ + "static/media/compliance_banner.23b5ee22.png";